import { render, staticRenderFns } from "./editStreetAdmin.vue?vue&type=template&id=72245952&scoped=true&"
import script from "./editStreetAdmin.vue?vue&type=script&lang=js&"
export * from "./editStreetAdmin.vue?vue&type=script&lang=js&"
import style0 from "./editStreetAdmin.vue?vue&type=style&index=0&id=72245952&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72245952",
  null
  
)

export default component.exports